export const DO_NOT_SHOW_TRIGGER_ALERT_STORAGE_KEY = 'DO_NO_SHOW_TRIGGER_ALERT'
